/**
 *
 * Form User Interface
 *
 *  Controls for the webform journey
 *
 *
 */

const $ = require('jQuery');
const _LStorage = require('./utilities/_LStorage.js');
const _Gsap = require('./utilities/_gsap');
const _Forms = require('./utilities/_form-controller');
const Deckable2 = require('./utilities/deckable2');
const { Foundation, dataLayer, ITBL } = window;
const disableSubmitButtonInForm = require('./src/run/form/disableSubmitButtonInForm');

var WebinarFormUI = function (el) {
    //setup variables
    this.$el = $(el);
    this.itblObj = 'iterable';
    this.ajaxCheck = null;
    this.$form = this.$el.find('.itbl-b-form');

    this.FormInstance = new Foundation.Abide(this.$form);

    //get all visible form input fields as array
    //so -- we have to filter out the partnerMarketing Opt in because we don't want local storage to save this data
    this.$visibleInputs = this.$form
      .find('select,input:not(input[type=submit]):not([type=hidden])')
        .map((i, el) => el.getAttribute('name'))
        .get();

    //booleans for checking the status of the webinar
    this.WebinarHasPassed = $(this.$el).hasClass('itbl-c-webinar--has-passed');
    this.Ondemand = $(this.$el).hasClass('itbl-c-webinar--is-on-demand');

    //get the known-user settings
    this.enable_knownUser = Object.prototype.hasOwnProperty.call(
        ITBL,
        'enable_known_user'
    );

    this.$formLoading = this.$el.find('.itbl-c-form__loading');

    this.$formSlide = this.$el.find('.itbl-c-form-contents');
    this.$ungated = this.$el.find('.itbl-c-form__ungated');
    this.$notUserCTA = this.$el.find('.itbl-c-form__ungated-not-user');

    //get the checkbox for knownuser customer privacy checkbox
    this.$customeroptIn = this.$el.find('#agree-to-partner-privacy-policy');
    this.$iterableOptIn = this.$el.find('#agree-to-iterables-privacy-policy');

    //confirmation
    //success message SVG classes
    this.$confirmation = this.$el.find('.itbl-c-form__confirmation');
    this.$confirmationWrap = this.$el.find(
        '.itbl-b-form__confirmation-overflow'
    );

    //returning user
    this.$userName = this.$el.find('.itbl-c-form__username');
    this.$returningUserCTA = this.$el.find('.itbl-c-form__ungated-cta');
    this.$userEmailEl = this.$el.find('.itbl-c-form__user-email');

    //data obj
    this.userAPIData = null;

    //get reveal elements in the document
    this.$reveal = $(document).find('#reveal-webinar-archive');
    this.video = document.getElementById('itbl-c-webinar__video');
    this.archiveVideoCTA = $(document).find(
        '.itbl-c-webinar__archive-video-preview'
    );

    //get the user email from localstorage
    //I'm electing to get these values in each function - this is too important to risk pulling as a global variable
    this.userEmail = _LStorage.decrypt__get('iterable/encrypted/Email');
    this.userFirstName = _LStorage.decrypt__get('iterable/encrypted/FirstName');
    this.userLastName = _LStorage.decrypt__get('iterable/encrypted/LastName');
    this.userPrivacy = _LStorage.decrypt__get(
        'iterable/encrypted/marketingConsent'
    );
    this.userCountry = _LStorage.decrypt__get('iterable/encrypted/Country');
    this.userCompany = _LStorage.decrypt__get('iterable/encrypted/Company');

    _Forms.debug('marketingConsent', this.userPrivacy);

    this.emailValues = {
        wp_email_to: 'forms@iterable.com',
        wp_email_subject: document.title + ' Webinar Form Registration',
        wp_email_message: null, //we gotta build this message body
    };

    //start building obj for API calls
    //all actions will use this obj, the models for handling the requests will take the fields they need
    this.APIState = Object.assign({}, this.emailValues);

    this.init();
};

WebinarFormUI.prototype.init = function () {
    //init the deckable class
    this.deckable = new Deckable2(this.$el).showHideLoading(true);

    //load all events
    this.events();

    //call the function controller for this Form UI feature
    this.controller__webinar();
};

//all events
WebinarFormUI.prototype.events = function () {
    //event for returning user registration
    this.$returningUserCTA.on(
        'click',
        this.event__returningUser_registration.bind(this)
    );

    //setup form events
    //this cancels all normal form events
    //also let's form abide take over
    this.$form
        .on('submit', _Forms.event__PreventDefault.bind(this))
        .on('forminvalid.zf.abide', _Forms.event__PreventDefault.bind(this))
        .on('formvalid.zf.abide', this.event__validFrom.bind(this));

    //for ungated page
    //clears data from localstorage
    //returns user to regular webform
    this.$notUserCTA.on('click', this.event__goToForm.bind(this));

    //testing
    this.$confirmationWrap.on('click', () => {
        _Gsap.confirmationAnimation(this.$confirmationWrap);
    });

    //shows the confirmation deck on CONF keyCode
    _Forms.event__keyCodeFn([67, 79, 78, 70], () => {
        this.deckable.goToDeck('confirmation');
    });

    //shows error message on ERO keyCode
    _Forms.event__keyCodeFn([69, 82, 79], () => {
        this.deckable.goToDeck('error');
    });

    //shows error message on KNOW keyCode
    _Forms.event__keyCodeFn([75, 78, 79, 87], () => {
        this.deckable.goToDeck('known-user');
    });

    // Prevent small screen page refresh sticky bug
    $(window).on('sticky.zf.unstuckfrom:bottom', function (e) {
        if (!Foundation.MediaQuery.atLeast('large')) {
            $(e.target)
                .removeClass('is-anchored is-at-bottom')
                .attr('style', '');
        }
    });

    //show webform on archived video click
    //if no local storage is available, will return to webform
    this.archiveVideoCTA.on('play', this.event__watchOnDemandFn.bind(this));

    //3/3/20 - adding a handler to add the customer opt-in for the known-user form
    this.$customeroptIn.on(
        'change',
        this.event__handleKnownUserCustomerPrivacy.bind(this)
    );
    this.$iterableOptIn.on(
        'change',
        this.event__handleknownUserIterablePolicy.bind(this)
    );

    this.$el.find(".itbl-c-form__known-user-cta").on("click", e => {
        e.preventDefault();
        this.event__watchOnDemandFn();
        this.deckable.goToDeck('confirmation');
    });
};

/**
 * event for handling return users registering for a webinar
 *
 * @param event
 */
WebinarFormUI.prototype.event__returningUser_registration = function (event) {
    event.preventDefault();

    //Show the loading biz
    this.deckable.hideAllDecks();

    //start building the object to send through the API calls
    //select all the hidden fields
    _Forms.helper__getHiddenMetadata(this.$form, this.APIState);

    //set any changes to marketingConsent in LocalStorage
    _LStorage.encrypted__set(
        'iterable/encrypted/marketingConsent',
        this.APIState.marketingConsent
    );

    //append the errorWatch Object to the payload if it exists
    if (Object.prototype.hasOwnProperty.call(ITBL, 'errorWatch')) {
        this.APIState.errorWatch = ITBL.errorWatch;
    }

    this.handle__marketoPost();
};

/**
 * On form submit, handles a valid submission and sends payload to marketo
 *
 * @param event
 * @returns {boolean}
 */
WebinarFormUI.prototype.event__validFrom = function (event) {
    //disable normal submit event
    event.preventDefault();

    //Show the loading biz
    this.deckable.hideAllDecks();

    //serialize this data into name/value
    _Forms.helper__addFormInputsToState(this.$form, this.APIState);

    /**
     * If this webinar has the partnerMarketingOptin Field, do not save it in localStorage
     * because it will be different for each webinar
     */
    let partnerMarketingIndex = this.$visibleInputs.indexOf(
        'partnerMarketingOptIn'
    );

    if (partnerMarketingIndex && partnerMarketingIndex != -1) {
        this.$visibleInputs.splice(partnerMarketingIndex, 1);
    }

    //by removing the partnerMarketingIndex from visibileInputs, the ensures it is not added to localStorage
    _Forms.helper__setAllEncryptedVals(this.$visibleInputs, this.APIState);

    this.handle__marketoPost();

    //just to be sure
    return false;
};

WebinarFormUI.prototype.handle__marketoPost = function () {
    disableSubmitButtonInForm(this.$form[0]);

    _Forms
        .marketo__submit(this.APIState, undefined, undefined, this.$form)
        .then(() => {
            if (dataLayer) {
                //trigger Google Tag Manager event for Adwords conversion here!
                dataLayer.push({ event: 'ajaxFormSubmitted' });
            }
        })
        .catch(() => {
            console.log('marketo error');
        })
        .finally(() => {
            //jump to success
            this.helper__goToConfirmation();

            this.ajaxCheck = true;

            _Forms.debug('finished API state', this.APIState);
        });
};

/**
 * event for sending the payload to marketo for watching the ondemand video
 *
 * @param event
 */
WebinarFormUI.prototype.event__watchOnDemandFn = function (event) {
    if (_LStorage.decrypt__get('iterable/encrypted/Email')) {
        //start building the object to send through the API calls
        //select all the hidden fields
        _Forms.helper__getHiddenMetadata(this.$form, this.APIState);

        if (this.ajaxCheck === null) {
            //append the errorWatch Object to the payload if it exists
            if (Object.prototype.hasOwnProperty.call(ITBL, 'errorWatch')) {
                this.APIState.errorWatch = ITBL.errorWatch;
            }

            //fire the API events
            _Forms.marketo__submit(this.APIState, undefined, undefined, this.$form).catch((e) => {
                console.log(e);
            });

            if (dataLayer) {
                //trigger Google Tag Manager event for Adwords conversion here!
                dataLayer.push({ event: 'ajaxFormSubmitted' });
            }

            this.ajaxCheck = true;
        }
    } else {
        this.deckable.goToDeck('form');
    }
};

WebinarFormUI.prototype.controller__webinar = function () {
    //if no archive video
    //&& the webinar has passed
    if (!this.archiveVideoCTA && this.WebinarHasPassed) {
        //if we don't have a video, show UI will display a waiting message shown on the known-user section
        this.deckable.goToDeck('known-user');

        //check if the email object is available by checking localstorage
        //we have an email here, run the returning user function
        // also check if known user fields are set
    } else if (this.userEmail && this.enable_knownUser) {
        this.view__returningUser();

        //no email, disable the loading screen and show the webform
    } else {
        this.deckable.goToDeck('form');
    }
};

WebinarFormUI.prototype.event__goToForm = function (event) {
    event.preventDefault();

    try {
        //important, we need to reset our values here, just in case there is data from somewhere else
        this.APIState = this.emailValues;
    } catch (e) {
        console.log('error', e);
    } finally {
        this.deckable.goToDeck('form');
    }
};

//if email is available,
WebinarFormUI.prototype.view__returningUser = function () {
    //if there is no values from getting the decrypted local storage - then show the form
    //One last Sanity check
    if (!this.userEmail || !this.userFirstName || !this.userLastName) {
        this.deckable.goToDeck('form');
    }

    //check localstorage for privacy value, if there is value, then remove the checkbox
    if (this.userPrivacy) {
        $(document)
            .find('.itbl-c-form__known_user_marketingConsent__wrap')
            .remove();
    }

    //get the email address/first name/ last name/company from API
    this.APIState.Email = this.userEmail;
    this.APIState.FirstName = this.userFirstName;
    this.APIState.LastName = this.userLastName;
    this.APIState.Company = this.userCompany;
    this.APIState.Country = this.userCountry;
    this.APIState.knownUser = 'true';

    //replace the text with the user's name
    $(this.$userName).text(this.userFirstName);

    //replace the text with the user's email
    $(this.$userEmailEl).text(`(${this.userEmail})`);

    //jump to ungated slide
    this.deckable.goToDeck('known-user');
};

WebinarFormUI.prototype.helper__goToConfirmation = function () {
    //move to success page
    this.deckable.goToDeck('confirmation');

    _Gsap.confirmationAnimation(this.$confirmationWrap);
};

WebinarFormUI.prototype.event__handleKnownUserCustomerPrivacy = function (
    event
) {
    const $target = $(event.currentTarget);

    _Forms.setMarketoPrivacyValues(
        $target,
        'partnerMarketingOptIn',
        this.APIState
    );

    _Forms.debug('updated APIState', this.APIState);
};

WebinarFormUI.prototype.event__handleknownUserIterablePolicy = function (
    event
) {
    const $target = $(event.currentTarget);

    _Forms.setMarketoPrivacyValues($target, 'marketingConsent', this.APIState);

    _Forms.debug('updated APIState', this.APIState);
};

$(document).ready(function () {
    $('.js-form-ui').each(function () {
        new WebinarFormUI(this);
    });
});
